import { render, staticRenderFns } from "./areaTemplate.vue?vue&type=template&id=3610ed94&scoped=true"
import script from "./areaTemplate.vue?vue&type=script&lang=js"
export * from "./areaTemplate.vue?vue&type=script&lang=js"
import style0 from "./areaTemplate.vue?vue&type=style&index=0&id=3610ed94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610ed94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3610ed94')) {
      api.createRecord('3610ed94', component.options)
    } else {
      api.reload('3610ed94', component.options)
    }
    module.hot.accept("./areaTemplate.vue?vue&type=template&id=3610ed94&scoped=true", function () {
      api.rerender('3610ed94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/controlPinForm/areaTemplate.vue"
export default component.exports